import { call, put, select } from "redux-saga/effects"

import userApi from "../../../api/user"
import {
  FETCH_USER_SUCCESS,
  FETCH_USER_FAILURE,
  CREATE_USER_SUCCESS,
  CREATE_USER_FAILURE,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILURE,
  FETCH_USER_DETAILS_SUCCESS,
  FETCH_USER_DETAILS_FAILURE,
  FETCH_LUCKY_DRAW_USER_FAILURE,
  FETCH_LUCKY_DRAW_USER_SUCCESS,
  FETCH_AWARD_USER_SUCCESS,
  FETCH_AWARD_USER_FAILURE,
  GET_PRODUCT_LIST_FAILURE,
  GET_PRODUCT_LIST_SUCCESS,
  GET_SYSTEM_USER_LIST_SUCCESS,
  GET_SYSTEM_USER_LIST_FAILURE,
  ADD_SYSTEM_USER_SUCCESS,
  ADD_SYSTEM_USER_FAILURE,
  EDIT_SYSTEM_USER_SUCCESS,
  EDIT_SYSTEM_USER_FAILURE,
  REMOVE_SYSTEM_USER_SUCCESS,
  REMOVE_SYSTEM_USER_FAILURE,
} from "../../types/user"

// Helper function to get auth token
const getAuthToken = state => state.auth.token

// Worker Sagas
export function* fetchUserWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield call([userApi, "fetchUser"], token, action.payload)
    if (response.error) {
      yield put({ type: FETCH_USER_FAILURE, payload: response.error })
    } else {
      yield put({
        type: FETCH_USER_SUCCESS,
        payload: response.data.users || response,
      })
    }
  } catch (error) {
    yield put({ type: FETCH_USER_FAILURE, payload: error.message })
  }
}

export function* createUserWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield call([userApi, "createUser"], token, action.payload)

    if (response.error) {
      yield put({ type: CREATE_USER_FAILURE, payload: response.error })
    } else {
      yield put({
        type: CREATE_USER_SUCCESS,
        payload: response.data || response,
      })
    }
  } catch (error) {
    yield put({ type: CREATE_USER_FAILURE, payload: error.message })
  }
}

export function* updateUserWorker(action) {
  try {
    const response = yield userApi.updateUser(
      action.payload.userData,
      action.payload.token
    )

    if (response.status === 200) {
      yield put({
        type: UPDATE_USER_SUCCESS,
        payload: {
          user: response.data.userData.user,
          // token: response.data.userData.user.token,
          dashboard_redirection_type:
            response.data.userData.user.dashboard_redirection_type,
          pvs_cards: response.data.userData.pvs_cards,
        },
      })
    } else {
      yield put({ type: UPDATE_USER_FAILURE, payload: response.error })
    }
  } catch (error) {
    yield put({
      type: UPDATE_USER_FAILURE,
      payload: { message: error.message },
    })
  }
}

export function* getProductListWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield userApi.getProductList(
      action.payload.pageData,
      token
    )

    if (response.status === 200) {
      yield put({
        type: GET_PRODUCT_LIST_SUCCESS,
        payload: { products: response.data.products },
      })
    } else {
      yield put({ type: GET_PRODUCT_LIST_FAILURE, payload: response.error })
    }
  } catch (error) {
    yield put({ type: GET_PRODUCT_LIST_FAILURE, payload: error.message })
  }
}

export function* deleteUserWorker(action) {
  try {
    const categoryId = action.payload
    const token = yield select(getAuthToken)
    const response = yield call([userApi, "deleteUser"], token, categoryId)

    if (response.error) {
      yield put({ type: DELETE_USER_FAILURE, payload: response.error })
    } else {
      yield put({ type: DELETE_USER_SUCCESS, payload: categoryId })
    }
  } catch (error) {
    yield put({ type: DELETE_USER_FAILURE, payload: error.message })
  }
}

export function* fetchUserDetailsWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield call(
      [userApi, "getUserDetails"],
      token,
      action.payload
    )
    console.log('response..', response);
    
    if (response.error) {
      yield put({ type: FETCH_USER_DETAILS_FAILURE, payload: response.error })
    } else {
      yield put({
        type: FETCH_USER_DETAILS_SUCCESS,
        payload: response.data.user || response,
      })
    }
  } catch (error) {
    yield put({ type: FETCH_USER_DETAILS_FAILURE, payload: error.message })
  }
}

export function* getSystemUserListWorker() {
  try {
    const token = yield select(getAuthToken)
    const response = yield userApi.getSystemUserList(token)

    if (response.status === 200) {
      yield put({
        type: GET_SYSTEM_USER_LIST_SUCCESS,
        payload: { users: response.data.users },
      })
    } else {
      yield put({
        type: GET_SYSTEM_USER_LIST_FAILURE,
        payload: response.data.message,
      })
    }
  } catch (error) {
    yield put({ type: GET_SYSTEM_USER_LIST_FAILURE, payload: error.message })
  }
}

export function* addSystemUserWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield userApi.addSystemUser(action.payload.data, token)

    if (response.status === 200 && response.data.success) {
      yield put({
        type: ADD_SYSTEM_USER_SUCCESS,
        payload: { message: response.data.message },
      })
    } else {
      yield put({
        type: ADD_SYSTEM_USER_FAILURE,
        payload: response.data.message,
      })
    }
  } catch (error) {
    yield put({ type: ADD_SYSTEM_USER_FAILURE, payload: error.message })
  }
}

export function* editSystemUserWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield userApi.editSystemUser(action.payload.data, token)

    if (response.status === 200 && response.data.success) {
      yield put({
        type: EDIT_SYSTEM_USER_SUCCESS,
        payload: { message: response.data.message },
      })
    } else {
      yield put({
        type: EDIT_SYSTEM_USER_FAILURE,
        payload: response.data.message,
      })
    }
  } catch (error) {
    yield put({ type: EDIT_SYSTEM_USER_FAILURE, payload: error.message })
  }
}

export function* removeSystemUserWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield userApi.removeSystemUser(action.payload.data, token)

    if (response.status === 200 && response.data.success) {
      yield put({
        type: REMOVE_SYSTEM_USER_SUCCESS,
        payload: { message: response.data.message },
      })
    } else {
      yield put({
        type: REMOVE_SYSTEM_USER_FAILURE,
        payload: response.data.message,
      })
    }
  } catch (error) {
    yield put({ type: REMOVE_SYSTEM_USER_FAILURE, payload: error.message })
  }
}

export function* fetchAwardUserWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield call(
      [userApi, "getAwardUser"],
      token,
      action.payload
    )

    if (response.error) {
      yield put({ type: FETCH_AWARD_USER_FAILURE, payload: response.error })
    } else {
      yield put({
        type: FETCH_AWARD_USER_SUCCESS,
        payload: response.data.awards || response,
      })
    }
  } catch (error) {
    yield put({ type: FETCH_AWARD_USER_FAILURE, payload: error.message })
  }
}

export function* fetchLuckyDrawUserWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield call(
      [userApi, "getLuckyDrawUser"],
      token,
      action.payload
    )

    if (response.error) {
      yield put({
        type: FETCH_LUCKY_DRAW_USER_FAILURE,
        payload: response.error,
      })
    } else {
      yield put({
        type: FETCH_LUCKY_DRAW_USER_SUCCESS,
        payload: response.data.luckyDraw || response,
      })
    }
  } catch (error) {
    yield put({ type: FETCH_LUCKY_DRAW_USER_FAILURE, payload: error.message })
  }
}
